module.exports = __webpack_public_path__ + "static/media/profile.d19df8fe.svg";